function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { businessGlossaryMixin } from '@/mixins/business_glossary';
// eslint-disable-next-line
import businessTermService from '@/apps/data-platform/services/master_data/business_term_service';
import tasks from '@/js/tasks';
import MultiSelect from '@/components/MultiSelect';
export default {
  name: 'FormBusinessTermsComponent',
  mixins: [businessGlossaryMixin],
  components: {
    MultiSelect: MultiSelect
  },
  props: {
    tplToWork: {
      type: Object,
      required: true
    },
    fDomain: {
      type: String,
      required: true
    },
    terms: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    idomain: {
      type: String,
      required: false,
      default: undefined
    },
    isubdomain: {
      type: String,
      required: false,
      default: undefined
    },
    view: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      e1: 0,
      register: {},
      type: '',
      kdomain: '',
      ksubdomain: '',
      kbusiness_term: '',
      business_term: '',
      definition: '',
      update_date: '',
      values: [],
      classification: [],
      also_known_as: '',
      accountable: '',
      critical: true,
      status: true,
      shared: false,
      is_contained_in: [],
      is_a_type_of: [],
      is_a_related_term_from: [],
      is_calculated_from: [],
      related_objects: [],
      selectTerms: [],
      labelDomain: '',
      DomainVariant: 'outline-primary',
      SubdomainVariant: 'outline-primary',
      labelSubdomain: '',
      isSubmitting: false,
      rules: {
        required: function required(value) {
          return !!value || 'Campo requerido.';
        },
        email: function email(value) {
          var pattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
          return pattern.test(value) || 'Debe ser un correo válido.';
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['isDomainItc'])), {}, {
    texts: function texts() {
      return {
        type: this.traductor('tablas.type'),
        bterm: this.traductor('tablas.bterm'),
        domain: this.traductor('tablas.domain'),
        subdomain: this.traductor('filtros.subdomain'),
        definition: this.traductor('tablas.definition'),
        values: this.traductor('tablas.values'),
        class: this.traductor('tablas.tags'),
        aka: this.traductor('tablas.aka'),
        accountable: this.traductor('tablas.accountable'),
        is_critical: this.traductor('frases.is_critical'),
        active: this.traductor('frases.active'),
        shared: this.traductor('frases.shared'),
        relationships: this.traductor('frases.relationships'),
        is_contained: this.traductor('frases.is_contained'),
        is_related: this.traductor('frases.is_related'),
        is_type: this.traductor('frases.is_type'),
        is_used: this.traductor('frases.is_used')
      };
    },
    availableOptions: function availableOptions() {
      var _this = this;
      return function (values) {
        var options = _this.terms.map(function (term) {
          return term.business_term;
        });
        return options.filter(function (opt) {
          return values.indexOf(opt) === -1 && opt != _this.register.business_term;
        });
      };
    }
  }),
  watch: {
    e1: function e1(val) {
      this.$emit('tab-change', val);
    }
  },
  created: function created() {
    var _this2 = this;
    console.log(this.tplToWork);
    this.userInfo = tasks.getUserInfo();
    this.cDomain = this.fDomain;
    this.selectTerms = this.terms.map(function (term) {
      return {
        value: term.business_term,
        text: term.business_term,
        kbusiness_term: term.kbusiness_term
      };
    });
    this.register = this.tplToWork.item;
    this.kdomain = this.register.kdomain;
    this.ksubdomain = this.register.ksubdomain;
    this.type = this.register.type;
    this.kbusiness_term = this.register.kbusiness_term;
    this.business_term = this.register.business_term;
    this.definition = this.register.definition;
    this.update_date = this.register.update_date;
    this.values = this.register.values;
    this.classification = this.register.classification;
    this.also_known_as = this.register.also_known_as;
    this.accountable = this.register.accountable;
    this.critical = this.register.critical;
    this.status = this.register.status;
    this.shared = this.register.shared || false;
    this.is_contained_in = this.register.relationship.is_contained_in || [];
    this.is_a_related_term_from = this.register.relationship.is_a_related_term_from || [];
    this.is_a_type_of = this.register.relationship.is_a_type_of || [];
    this.is_calculated_from = this.register.relationship.is_calculated_from || [];
    this.related_objects = this.register.related_object;
    var idx, i;
    if (this.is_contained_in) {
      for (i = 0; i < this.is_contained_in.length; i++) {
        idx = this.selectTerms.findIndex(function (bterm) {
          return bterm.kbusiness_term.includes(_this2.is_contained_in[i]);
        });
        if (idx != -1) {
          console.log(this.selectTerms, idx);
          this.is_contained_in[i] = this.selectTerms[idx].text;
        }
      }
    }
    if (this.is_a_type_of) {
      for (i = 0; i < this.is_a_type_of.length; i++) {
        idx = this.selectTerms.findIndex(function (bterm) {
          return bterm.kbusiness_term.includes(_this2.is_a_type_of[i]);
        });
        if (idx != -1) this.is_a_type_of[i] = this.selectTerms[idx].value;
      }
    }
    if (this.is_a_related_term_from) {
      for (i = 0; i < this.is_a_related_term_from.length; i++) {
        idx = this.selectTerms.findIndex(function (bterm) {
          return bterm.kbusiness_term.includes(_this2.is_a_related_term_from[i]);
        });
        if (idx != -1) this.is_a_related_term_from[i] = this.selectTerms[idx].value;
      }
    }
    if (this.is_calculated_from) {
      for (i = 0; i < this.is_calculated_from.length; i++) {
        idx = this.selectTerms.findIndex(function (bterm) {
          return bterm.kbusiness_term.includes(_this2.is_calculated_from[i]);
        });
        if (idx != -1) this.is_calculated_from[i] = this.selectTerms[idx].value;
      }
    }
  },
  methods: {
    nextStep: function nextStep() {
      if (!this.$refs.form.validate()) return;
      this.e1++;
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onSubmit: function onSubmit(event) {
      var _this3 = this;
      event.preventDefault();
      if (this.business_term && this.kdomain && this.ksubdomain) {
        var bterm = this.business_term;
        var upper = bterm.toUpperCase();
        this.business_term = upper;
        var businessDomain = {
          domain: this.cDomain,
          shared: false,
          clauses: {
            business_term: this.business_term
          }
        };
        businessTermService.getBusinessTerms(businessDomain).then(function (response) {
          if (response.data.result.length !== 0) {
            if (!(_this3.kbusiness_term === response.data.result[0].kbusiness_term)) {
              tasks.toast.error('Business term already exists');
              //alert('Business term already exists')
            } else {
              _this3.saveChangeRequest();
            }
          } else {
            _this3.saveChangeRequest();
          }
        });
      } else if (!this.business_term) {
        tasks.toast.error('Complete the business term');
        //alert('Complete the business term')
      } else if (!this.kdomain) {
        tasks.toast.error('Complete the business domain');
        //alert('Complete the business domain')
      } else if (!this.ksubdomain) {
        tasks.toast.error('Complete the business subdomain');
        //alert('Complete the business subdomain')
      }
    },
    saveChangeRequest: function saveChangeRequest() {
      var _this4 = this;
      this.isSubmitting = true;
      var now = new Date().toISOString().slice(0, 10);
      var is_contained_in = [];
      var is_a_type_of = [];
      var is_a_related_term_from = [];
      var is_calculated_from = [];
      var idx, i;
      this.selectTerms.kbusiness_term;
      if (this.is_contained_in) {
        for (i = 0; i < this.is_contained_in.length; i++) {
          idx = this.selectTerms.findIndex(function (bterm) {
            return bterm.value.includes(_this4.is_contained_in[i]);
          });
          is_contained_in[i] = this.selectTerms[idx].kbusiness_term;
        }
      }
      if (this.is_a_type_of) {
        for (i = 0; i < this.is_a_type_of.length; i++) {
          idx = this.selectTerms.findIndex(function (bterm) {
            return bterm.value.includes(_this4.is_a_type_of[i]);
          });
          is_a_type_of[i] = this.selectTerms[idx].kbusiness_term;
        }
      }
      if (this.is_a_related_term_from) {
        for (i = 0; i < this.is_a_related_term_from.length; i++) {
          idx = this.selectTerms.findIndex(function (bterm) {
            return bterm.value.includes(_this4.is_a_related_term_from[i]);
          });
          is_a_related_term_from[i] = this.selectTerms[idx].kbusiness_term;
        }
      }
      if (this.is_calculated_from) {
        for (i = 0; i < this.is_calculated_from.length; i++) {
          idx = this.selectTerms.findIndex(function (bterm) {
            return bterm.value.includes(_this4.is_calculated_from[i]);
          });
          is_calculated_from[i] = this.selectTerms[idx].kbusiness_term;
        }
      }
      if (!this.status) {
        tasks.toast.error("A term with status \"Inactive\" can\xB4t be assigned to an object");
        //alert(`A term with status "Inactive" can´t be assigned to an object`)
      }
      var bt_domain = this.selectDomain.find(function (element) {
        return element.value === _this4.kdomain;
      }).text;
      var bt_subdomain = this.selectSubdomain.find(function (element) {
        return element.domain === _this4.kdomain;
      }).text;
      var businessTerm = {
        domain: this.cDomain,
        glossary_term: {
          type: this.type,
          kdomain: this.kdomain,
          ksubdomain: this.ksubdomain,
          kbusiness_term: this.kbusiness_term,
          business_term: this.business_term,
          definition: this.definition,
          update_date: now,
          values: this.values,
          classification: this.classification,
          also_known_as: this.also_known_as,
          accountable: this.accountable,
          critical: this.critical,
          status: this.status,
          shared: this.shared,
          relationship: {
            contains: [],
            related_term: [],
            has_a_type: [],
            is_used_to_calculate: [],
            is_contained_in: is_contained_in,
            is_a_related_term_from: is_a_related_term_from,
            is_a_type_of: is_a_type_of,
            is_calculated_from: is_calculated_from
          },
          related_objects: [],
          params: '',
          bt_domain: bt_domain,
          bt_subdomain: bt_subdomain
        }
      };
      var request = this.tplToWork.type === 'Insert' ? businessTermService.createBusinessTerm(businessTerm) : businessTermService.updateBusinessTerm(businessTerm);
      return request.then(function (response) {
        _this4.$emit('submit');
      }).finally(function () {
        _this4.isSubmitting = false;
      });
    },
    onCancel: function onCancel(event) {
      event.preventDefault();
      this.$emit('cancel', null);
    }
  }
};